import { ReactNode } from 'react'
import { Setting2, LogoutCurve } from 'iconsax-reactjs'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { LOGOUT_USER } from '../../redux/auth'

interface UserDropdownProps {
  children: ReactNode
  align?: "start" | "center" | "end"
  side?: "top" | "right" | "bottom" | "left"
}

const UserDropdown = ({ children, align = "start", side }: UserDropdownProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const logout = async () => {
    LOGOUT_USER(dispatch);
    navigate("/");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[227px] mb-2 rounded-2xl p-1 overflow-hidden border-0 bg-white" align={align} side={side} sideOffset={12}>
        <DropdownMenuLabel className="px-5 pt-4 pb-3 text-xs font-bold text-gray-70 uppercase tracking-wider">
          Account
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-[#F0F2FD] h-[1px] mx-0 my-0" />
        <div className="p-2 space-y-1">
          {/* <Link to="/settings/home"> */}
          <Link to="/account-settings">
            <DropdownMenuItem className="flex items-center gap-2 px-3 py-2 cursor-pointer rounded-[8px] focus:bg-gray-50 focus:text-gray-30 text-gray-10 transition-all duration-200 outline-none data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed">
              <span className="text-[#8D92BC] subgroup-focus:text-primary-30">
                <Setting2 size={32} variant="Outline" />
              </span>
              <span className="text-base text-gray-10 font-[450]">Settings</span>
            </DropdownMenuItem>
          </Link>
          <DropdownMenuItem onClick={logout} className="flex items-center gap-2 px-3 py-2 cursor-pointer rounded-[8px] focus:bg-gray-50 focus:text-gray-30 text-gray-10 transition-all duration-200 outline-none data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed">
            <span className="text-[#8D92BC] subgroup-focus:text-primary-30">
              <LogoutCurve size={32} variant="Outline" />
            </span>
            <span className="text-base text-gray-10 font-[450]">Log out</span>
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default UserDropdown
